import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { MessageService } from './message.service';
import { BrandSeed } from '../models/BrandSeed';

@Injectable({ providedIn: 'root' })

export class BrandSeedService { 
  private _ENDPOINT = '';

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient,
    private messageService: MessageService, @Inject('BASE_URL') baseUrl) {
    this._ENDPOINT = baseUrl + 'api/brandSeeds';   
  }
 
  getAll(brandId: any): Observable<Array<BrandSeed>> { 
    return this.http.get<Array<BrandSeed>>(this._ENDPOINT + '?brandId=' + brandId);
  }
   
  getById(id: any): Observable<BrandSeed> {
    const url = this._ENDPOINT+'/'+id;
    return this.http.get<BrandSeed>(url);
  }

  /** POST: add a new brandSeed to the server */
  add(brandSeed: BrandSeed): Observable<BrandSeed> {
    return this.http.post<BrandSeed>(this._ENDPOINT, brandSeed, this.httpOptions).pipe(
      tap((newBrandSeed: BrandSeed) => this.log('added brandSeed w/ id=${newBrandSeed.id}')),
      catchError(this.handleError<BrandSeed>('add'))
    );
  }

  /** DELETE: delete the brandSeed from the server */
  delete(brandSeed: BrandSeed | number): Observable<BrandSeed> {
    const id = typeof brandSeed === 'number' ? brandSeed : brandSeed.id;
    const url = this._ENDPOINT + '/' + id;

    return this.http.delete<BrandSeed>(url, this.httpOptions).pipe(
      tap(_ => this.log('deleted brandSeed id=${id}')),
      catchError(this.handleError<BrandSeed>('delete'))
    );
  }

  /** PUT: update the brandSeed on the server */
  update(id: number, brandSeed: BrandSeed): Observable<any> {
    return this.http.put(this._ENDPOINT + "/" + id, brandSeed , this.httpOptions).pipe(
      tap(_ => this.log('updated brandSeed id=${brandSeed.Id}')),
      catchError(this.handleError<any>('update'))
    );
  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log('${operation} failed: ${error.message}');

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  /** Log a BrandSeedService message with the MessageService */
  private log(message: string) {
    this.messageService.add('BrandSeedService: ${message}');
  }
}
